// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"380":"WindHome","779":"SolarHome"}[chunkId] || chunkId) + "." + {"380":"6031d52a","779":"d2705116","889":"404731b0"}[chunkId] + ".js";
};